import { MoneyPage } from "@/components/money-page/MoneyPage";
import { seoConsultantPage } from "@/data/money-pages/seoConsultant";
import { seoAuditPage } from "@/data/money-pages/seoAudit";
import { technicalSeoPage } from "@/data/money-pages/technicalSeo";
import { internationalSeoPage } from "@/data/money-pages/internationalSeo";
import { hispanicSeoPage } from "@/data/money-pages/hispanicSeo";
import { ecommerceSeoPage } from "@/data/money-pages/ecommerceSeo";
import { amazonSeoPage } from "@/data/money-pages/amazonSeo";
import { aiSearchPage } from "@/data/money-pages/aiSearch";
import { googleAdsPage } from "@/data/money-pages/googleAds";
import { seoSemStrategiesPage } from "@/data/money-pages/seoSemStrategies";
import { rebrandingSeoPage } from "@/data/money-pages/rebrandingSeo";
import { contentConversionPage } from "@/data/money-pages/contentConversion";
import { brandingPage } from "@/data/money-pages/branding";
import { websiteRedesignPage } from "@/data/money-pages/websiteRedesign";

export const SeoConsultantMoneyPage = () => <MoneyPage content={seoConsultantPage} />;
export const SeoAuditMoneyPage = () => <MoneyPage content={seoAuditPage} />;
export const TechnicalSeoMoneyPage = () => <MoneyPage content={technicalSeoPage} />;
export const InternationalSeoMoneyPage = () => <MoneyPage content={internationalSeoPage} />;
export const HispanicSeoMoneyPage = () => <MoneyPage content={hispanicSeoPage} />;
export const EcommerceSeoMoneyPage = () => <MoneyPage content={ecommerceSeoPage} />;
export const AmazonSeoMoneyPage = () => <MoneyPage content={amazonSeoPage} />;
export const AiSearchMoneyPage = () => <MoneyPage content={aiSearchPage} />;
export const GoogleAdsMoneyPage = () => <MoneyPage content={googleAdsPage} />;
export const SeoSemStrategiesMoneyPage = () => <MoneyPage content={seoSemStrategiesPage} />;
export const RebrandingSeoMoneyPage = () => <MoneyPage content={rebrandingSeoPage} />;
export const ContentConversionMoneyPage = () => <MoneyPage content={contentConversionPage} />;
export const BrandingMoneyPage = () => <MoneyPage content={brandingPage} />;
export const WebsiteRedesignMoneyPage = () => <MoneyPage content={websiteRedesignPage} />;
